import React from "react";
import '../gridcontent/gridcontent.css'
import codeimg from '../../images/code.svg'
import design from '../../images/design.png'
import packageoffered from '../../images/packageoffered.svg'

export default function GridContent() {
    return (
        <div className="grid-container">

            <h2 className="responsivePricingTable" ><br/></h2>

            <div className="columns">
                <ul className="price">
                    
                    <li className="header">  <img className="itemimg" src={design} /><h1>Website Services </h1></li>
                    <li className="grey">Design & Development</li>
                    <li>(Static/Responsive/Dynamic) Website</li>
                    <li>Landing Page</li>
                    <li>Web App</li>
                    <li>SEO</li>
                    <li>UX Design</li>
                    <li>UI  Design</li>
                    <li className="grey"><a href="#" className="button">Sign Up</a></li>
                </ul>
            </div>

            <div className="columns">
                <ul className="price">
                    <li className="header" >   <img className="itemimg" src={codeimg} /><h1>FullStack Developer</h1></li>
                    <li className="grey">TechStack</li>
                    <li>JavaScript</li>
                    <li>React.js & Native</li>
                    <li>Java</li>
                    <li>Node.js</li>
                    <li>Express.js</li>
                    <li>SQL & More</li>
             
                    <li className="grey"><a href="#" className="button">Sign Up</a></li>
                </ul>
            </div>

            <div className="columns">
                <ul className="price">
                    <li className="header"> <img className="itemimg" src={packageoffered} /> <h1>Working Together</h1></li>
                    <li className="grey">$$$</li>
                    <li> $100.00 USD / Static Website</li>
                    <li> $300.00 USD / Responsive Website</li>
                    <li> $400.00 USD / Dynamic Website</li>
                    <li> $500.00 USD / Landing Page Website</li>
                    <li> $1,000.00 USD / Web App</li>
                    <li> $3,000.00 USD / Mobile App</li>
                    <li className="grey"><a href="#" className="button">Sign Up</a></li>
                </ul>
            </div>
        </div>
    )
}